module.exports = __webpack_public_path__ + "static/media/slide-link.67b9e950.svg";